<template>
  <div id="app">
    <NavBar />
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <component :is="Component" :key="$route.name" v-if="!$route.meta.keepAlive" />
      </router-view>
    <FooterBar />
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, watch, provide, ref, computed, ComputedRef } from 'vue'
import './common.less'
import NavBar from '@/components/NavBar.vue'
import provide_key from '@/constant/provide_key'
import FooterBar from './components/FooterBar.vue'

const windowWdith = ref<number>(0)
const visibleWdith = 1027
const shrink:ComputedRef<boolean> = computed(() => windowWdith.value < visibleWdith)

const onResize = () => windowWdith.value = window.innerWidth
window.addEventListener('resize', onResize)
window.addEventListener('reset', onResize)

onUnmounted(() => window.removeEventListener('resize', onResize))

watch(() => window.innerHeight, () => windowWdith.value = window.innerWidth, {immediate: true})

provide(provide_key.SHRINK, shrink)

</script>


<style lang="less" scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: "HarmonyOS_Regular";
}
</style>
